export default "__VITE_ASSET__BpQRDhNN__"